import { Play, Clock } from "lucide-react";
import { useState } from "react";
import ShareEpisode from "@/components/ShareEpisode";

export default function EpisodeCard({ episode, onPlay, dark = false }) {
  const [shareOpen, setShareOpen] = useState(false);
  return (
    <article
      data-testid={`episode-card-${episode.id}`}
      className={`jt-card group relative w-[260px] md:w-[300px] rounded-2xl overflow-hidden cursor-pointer border ${
        dark
          ? "bg-[#14100B] border-white/10 hover:border-[#E63946]/60"
          : "bg-white border-[#E5D9C5] jt-soft-shadow"
      }`}
      onClick={() => !shareOpen && onPlay?.(episode)}
    >
      <div className={`relative aspect-[16/10] overflow-hidden ${dark ? "bg-black" : "bg-[#F5EDDE]"}`}>
        {episode.image_url ? (
          <img
            src={episode.image_url}
            alt={episode.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <div className={`w-full h-full flex items-center justify-center font-display text-4xl tracking-widest ${dark ? "text-[#E63946]" : "text-[#14100B]"}`}>
            JT
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
        <div className="absolute bottom-3 left-3 h-11 w-11 rounded-full bg-[#E63946] flex items-center justify-center jt-red-glow transition-transform group-hover:scale-110">
          <Play className="w-5 h-5 text-white translate-x-[1px]" fill="currentColor" />
        </div>
        {episode.duration && (
          <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 text-[11px] px-2 py-1 rounded-full bg-black/60 text-white backdrop-blur-sm">
            <Clock className="w-3 h-3" /> {episode.duration}
          </span>
        )}
        <div className="absolute top-3 right-3 z-10 opacity-0 group-hover:opacity-100 transition-opacity">
          <ShareEpisode episode={episode} onOpenChange={setShareOpen} />
        </div>
      </div>
      <div className="p-4">
        <h4 className={`font-serif text-lg leading-snug line-clamp-2 min-h-[3rem] ${dark ? "text-white" : "text-[#14100B]"}`}>
          {episode.title}
        </h4>
        <p className={`text-xs mt-2 line-clamp-2 ${dark ? "text-white/60" : "text-[#6B5A48]"}`}>
          {episode.description}
        </p>
      </div>
    </article>
  );
}
